
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { contains, tryFind, filter, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { unwrap, map as map_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { MultiSelect, Select } from "../Components/Select.js";
import { FormState__getValidation } from "../Shared/Shared.js";
import { stringHash } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export function BusinessUnitSelect(props) {
    const t = useTranslation()[0];
    const mapBusinessUnit = (businessUnit) => ({
        label: businessUnit.Name,
        value: businessUnit,
    });
    const options = map(mapBusinessUnit, filter((businessUnit_1) => {
        const matchValue = props.SelectedBusinessUnitId;
        if (matchValue == null) {
            return true;
        }
        else {
            return businessUnit_1.Id !== matchValue;
        }
    }, props.BusinessUnits));
    let selectedBusinessUnit;
    const matchValue_1 = props.SelectedBusinessUnitId;
    if (matchValue_1 == null) {
        selectedBusinessUnit = undefined;
    }
    else {
        const businessUnitId_1 = matchValue_1;
        selectedBusinessUnit = map_1(mapBusinessUnit, tryFind((businessUnit_2) => (businessUnit_2.Id === businessUnitId_1), props.BusinessUnits));
    }
    return createElement(Select, {
        ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
        IsClearable: true,
        Label: t("business_units.business_unit"),
        NoOptionsMessage: "business_units.select.no_options",
        OnChange: props.OnChange,
        Options: options,
        PlaceholderKey: "business_units.select.placeholder",
        TestId: "business-unit-select",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "business_unit")),
        Value: unwrap(selectedBusinessUnit),
    });
}

export function BusinessUnitMultiSelect(props) {
    const t = useTranslation()[0];
    const mapBusinessUnit = (businessUnit) => ({
        label: businessUnit.Name,
        value: businessUnit,
    });
    const options = map(mapBusinessUnit, filter((businessUnit_1) => !contains(businessUnit_1.Id, props.SelectedBusinessUnitIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), props.BusinessUnits));
    const selectedBusinessUnits = map(mapBusinessUnit, filter((businessUnit_2) => contains(businessUnit_2.Id, props.SelectedBusinessUnitIds, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    }), props.BusinessUnits));
    return createElement(MultiSelect, {
        ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
        IsClearable: true,
        Label: t("business_units.business_unit"),
        NoOptionsMessage: "business_units.select.no_options",
        OnChange: props.OnChange,
        Options: options,
        PlaceholderKey: "business_units.select.placeholder",
        TestId: "business-unit-multi-select",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "business_unit")),
        Value: selectedBusinessUnits,
    });
}

